import AOS from 'aos';

AOS.init({
    once: true,
    offset: 100,
    startEvent: 'load',
});
AOS.refresh(true);

$(window).on('scroll', function () {
  AOS.refresh();
});

// set transition delay to zero
$(document).on('mouseover', '.aos-animate.aos-init', function () {
  $(this).addClass('aos-animation-ready');
});

if ($(window).width() <= 768) {
  $('body.home div#content + section.txt div[data-aos="zoom-in"]').attr('data-aos-offset', '-10');
}
